module.exports = __webpack_public_path__ + "img/zfb.6494edd9.png";